import { AnimatePresence, motion } from "framer-motion";

// Admin paneli için özel onay penceresi.
// Not: window.confirm() bazı tarayıcılarda (uygulama içi webview vb.) engellenir;
// bu yüzden tüm kritik işlemler bu bileşeni kullanır.
export const ConfirmDialog = ({
  open,
  title = "Emin misiniz?",
  message,
  confirmLabel = "Evet, Onayla",
  onConfirm,
  onCancel,
}) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        className="fixed inset-0 z-[200] flex items-center justify-center bg-ink-950/60 p-5"
        onClick={onCancel}
        data-testid="confirm-dialog"
      >
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="w-full max-w-sm border border-line bg-white p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="text-base font-bold tracking-tight text-ink-900" data-testid="confirm-title">{title}</p>
          {message && <p className="mt-2 text-sm leading-relaxed text-ink-500">{message}</p>}
          <div className="mt-6 flex gap-3">
            <button onClick={onCancel} data-testid="confirm-cancel" className="btn-outline-dark flex-1 !py-2.5">
              Vazgeç
            </button>
            <button onClick={onConfirm} data-testid="confirm-ok" className="btn-primary flex-1 !py-2.5">
              {confirmLabel}
            </button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
